exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".toggleBoxGroup--3vzle {\n    display: grid;\n    -webkit-box-align: left;\n    -webkit-align-items: left;\n       -moz-box-align: left;\n            align-items: left;\n    background-color: #4E4E4E;\n}", ""]);

// Exports
exports.locals = {
	"toggleBoxGroup": "toggleBoxGroup--3vzle"
};